// extracted by mini-css-extract-plugin
export default {"wrapper":"Switch_wrapper__DOcrO","track":"Switch_track__zhnB3","slider":"Switch_slider__HKwTu","label":"Switch_label__91p3y"};